var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDomainChecker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 45,
    viewBox: "0 0 44 45",
    width: 44,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 10.2064,
    x2: 41.7948,
    y1: 34.9857,
    y2: 1.67001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4312a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25638,
    stopColor: "#6233df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#849bff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.5 11c-3.7478 0-7.074 1.814-9.1753 4.6h-.0247v.0314c-1.4376 1.9198-2.3 4.293-2.3 6.8686 0 6.3377 5.1623 11.5 11.5 11.5s11.5-5.1623 11.5-11.5-5.1623-11.5-11.5-11.5zm3.45 2.9716c3.3754 1.3609 5.75 4.6559 5.75 8.5284 0 2.401-.9193 4.5751-2.4168 6.2104-.2942-.9311-1.1544-1.6104-2.1832-1.6104h-1.15v-3.45c0-.6348-.5152-1.15-1.15-1.15h-5.75v-2.3h1.15c.6348 0 1.15-.5152 1.15-1.15v-2.3h2.3c1.2707 0 2.3-1.0293 2.3-2.3zm-12.4119 6.4665 2.0619 2.0619 3.45 3.45v1.15c0 1.2708 1.0292 2.3 2.3 2.3v2.2214c-4.5474-.5641-8.05-4.4171-8.05-9.1214 0-.7105.0869-1.3984.2381-2.0619z",
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainChecker);
export default __webpack_public_path__ + "static/media/domain-checker.faeeef4e29568242ed9f86825b4c2e0a.svg";
export { ForwardRef as ReactComponent };